/**
 * Packshot Carousel Module
 * Strzałki prev/next zmieniają aktywny packshot w podglądzie.
 * Miniaturki scrollowalne (swipe/drag), kliknięcie też zmienia podgląd.
 *
 * Użycie:
 *   <section class="packshot-carousel">
 *     <img class="packshot-carousel__preview-img" src="...">
 *     <div class="product-nav product-nav--packshot-carousel">
 *       <button class="product-nav__arrow--prev">
 *       <div class="product-nav__items">
 *         <div class="product-nav__item" data-packshot-src="...">
 *       </div>
 *       <button class="product-nav__arrow--next">
 *     </div>
 *   </section>
 */

(function () {
    'use strict';

    var SELECTORS = {
        carousel: '.packshot-carousel',
        preview: '.packshot-carousel__preview-img',
        nav: '.product-nav--packshot-carousel',
        items: '.product-nav__items',
        item: '.product-nav__item[data-packshot-src]',
        prevBtn: '.product-nav__arrow--prev',
        nextBtn: '.product-nav__arrow--next'
    };

    var CLASSES = {
        active: 'is-active',
        fading: 'is-fading',
        disabled: 'is-disabled'
    };

    function init() {
        var carousels = document.querySelectorAll(SELECTORS.carousel);
        if (!carousels.length) return;

        carousels.forEach(function (carousel) {
            var preview = carousel.querySelector(SELECTORS.preview);
            var nav = carousel.querySelector(SELECTORS.nav);
            if (!preview || !nav) return;

            var itemsContainer = nav.querySelector(SELECTORS.items);
            var items = Array.prototype.slice.call(nav.querySelectorAll(SELECTORS.item));
            var prevBtn = nav.querySelector(SELECTORS.prevBtn);
            var nextBtn = nav.querySelector(SELECTORS.nextBtn);

            if (!itemsContainer || !items.length || !prevBtn || !nextBtn) return;

            var currentIndex = 0;

            // Znajdź indeks aktywnego elementu
            items.forEach(function (item, i) {
                if (item.classList.contains(CLASSES.active)) {
                    currentIndex = i;
                }
            });

            // =====================
            // Zmiana packshota
            // =====================
            function selectPackshot(index) {
                // Wrap around (circular)
                var len = items.length;
                currentIndex = ((index % len) + len) % len;

                // Ustaw aktywną miniaturkę
                items.forEach(function (item) {
                    item.classList.remove(CLASSES.active);
                });
                items[currentIndex].classList.add(CLASSES.active);

                // Scroll do aktywnego elementu
                scrollToItem(items[currentIndex]);

                // Fade out → zmień src → fade in
                var src = items[currentIndex].getAttribute('data-packshot-src');
                if (!src) return;

                preview.classList.add(CLASSES.fading);
                setTimeout(function () {
                    preview.src = src;
                    var thumbImg = items[currentIndex].querySelector('img');
                    preview.alt = thumbImg ? thumbImg.alt : 'Packshot';
                    preview.classList.remove(CLASSES.fading);
                }, 300);
            }

            // =====================
            // Strzałki prev/next (circular — zawsze aktywne)
            // =====================
            prevBtn.classList.remove(CLASSES.disabled);
            nextBtn.classList.remove(CLASSES.disabled);

            prevBtn.addEventListener('click', function () {
                selectPackshot(currentIndex - 1);
            });

            nextBtn.addEventListener('click', function () {
                selectPackshot(currentIndex + 1);
            });

            // =====================
            // Kliknięcie miniaturki
            // =====================
            items.forEach(function (item, i) {
                item.addEventListener('click', function () {
                    selectPackshot(i);
                });
                item.style.cursor = 'pointer';
            });

            // =====================
            // Scroll miniaturek
            // =====================
            function scrollToItem(item) {
                var itemLeft = item.offsetLeft;
                var containerWidth = itemsContainer.clientWidth;
                var itemWidth = item.offsetWidth;
                var scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);
                itemsContainer.scrollTo({
                    left: Math.max(0, scrollTo),
                    behavior: 'smooth'
                });
            }

            // =====================
            // Swipe na podglądzie
            // =====================
            var previewContainer = carousel.querySelector('.packshot-carousel__preview');
            if (previewContainer) {
                var startX = 0;
                var isDragging = false;
                var swipeThreshold = 50; // min px do zmiany

                // Zapobiegaj domyślnemu przeciąganiu obrazów
                preview.addEventListener('dragstart', function (e) {
                    e.preventDefault();
                });

                // Mouse events
                previewContainer.addEventListener('mousedown', function (e) {
                    isDragging = true;
                    startX = e.clientX;
                });

                document.addEventListener('mousemove', function (e) {
                    if (!isDragging) return;
                    e.preventDefault();
                });

                document.addEventListener('mouseup', function (e) {
                    if (!isDragging) return;
                    isDragging = false;
                    var deltaX = e.clientX - startX;
                    if (Math.abs(deltaX) >= swipeThreshold) {
                        if (deltaX < 0) {
                            selectPackshot(currentIndex + 1);
                        } else {
                            selectPackshot(currentIndex - 1);
                        }
                    }
                });

                // Touch events
                previewContainer.addEventListener('touchstart', function (e) {
                    startX = e.touches[0].clientX;
                }, { passive: true });

                previewContainer.addEventListener('touchend', function (e) {
                    var endX = e.changedTouches[0].clientX;
                    var deltaX = endX - startX;
                    if (Math.abs(deltaX) >= swipeThreshold) {
                        if (deltaX < 0) {
                            selectPackshot(currentIndex + 1);
                        } else {
                            selectPackshot(currentIndex - 1);
                        }
                    }
                });
            }

            // Scroll do aktywnego elementu na starcie (bez animacji)
            itemsContainer.scrollTo({ left: 0, behavior: 'instant' });
        });
    }

    // Expose for dynamic re-initialization (e.g. configurator limited mode)
    window.initPackshotCarousel = init;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
